/**
 * promo-price-badge.js
 *
 * Keeps the .promo-price-badge (see snippets/promo-price-badge.liquid)
 * in sync with the selected variant. theme.js already dispatches a
 * native 'variantPriceChange' CustomEvent (detail.variant, price in
 * cents) directly on the product's own section container whenever the
 * shopper picks a different variant - see _updatePrice() in
 * assets/theme.js - but that event does not bubble, so we bind our
 * own listener on the same [data-section-type="product"] container
 * rather than trying to delegate from document.
 *
 * Reuses theme.Currency.formatMoney + theme.settings.moneyFormat, the
 * exact same helper theme.js itself uses for the real price, so
 * formatting always matches (including theme.js's own quirk of
 * dropping the currency code after a JS-driven update - same as the
 * real price does).
 *
 * ROLLBACK: delete this file, snippets/promo-price-badge.liquid, and
 * that snippet's three render calls.
 */
(function () {
  function updateBadge(section, variant) {
    var badge = section.querySelector('.promo-price-badge');
    if (!badge || !variant) {
      return;
    }

    var pct = parseFloat(badge.getAttribute('data-promo-pct'));
    if (!pct || isNaN(pct)) {
      return;
    }

    var wasEl = badge.querySelector('[data-promo-was]');
    var nowEl = badge.querySelector('[data-promo-now]');
    if (!wasEl || !nowEl) {
      return;
    }

    // Nothing has been marked down in Shopify's own data, so the
    // struck-through price is just the real (regular) price.
    var wasPriceCents = variant.price;
    var nowPriceCents = Math.round(wasPriceCents * (1 - pct / 100));

    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      var moneyFormat = (window.theme.settings && theme.settings.moneyFormat) || '${{amount}}';
      wasEl.innerHTML = theme.Currency.formatMoney(wasPriceCents, moneyFormat);
      nowEl.innerHTML = theme.Currency.formatMoney(nowPriceCents, moneyFormat);
    }
  }

  function bind() {
    var sections = document.querySelectorAll('[data-section-type="product"]');
    for (var i = 0; i < sections.length; i++) {
      (function (section) {
        section.addEventListener('variantPriceChange', function (evt) {
          updateBadge(section, evt.detail && evt.detail.variant);
        });
      })(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
